import { api } from "@/frontend/services/api";
import type {
  CreateTournamentStatusRequestDTO,
  UpdateTournamentStatusRequestDTO,
  TournamentStatusResponseDTO,
  TournamentStatusesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/tournament-statuses/private";

export const tournamentStatusService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<
      ApiResponse<TournamentStatusesPaginatedResponseDTO>
    >(BASE_URL, params);
  },
  getById: (id?: string) =>
    api.get<ApiResponse<TournamentStatusResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateTournamentStatusRequestDTO) =>
    api.post<ApiResponse<TournamentStatusResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateTournamentStatusRequestDTO) =>
    api.put<ApiResponse<TournamentStatusResponseDTO>>(
      `${BASE_URL}/${id}`,
      data,
    ),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
